import { ApiType } from "@gymflow/common";
import { AutomationType } from "@gymflow/types";
import { useQuery } from "@tanstack/react-query";

import { automationQueryKeys } from "./automationQueryKeys";

export async function automationPlaceholderLabelsQueryFn({
  api,
  placeholderType,
}: {
  api: ApiType;
  placeholderType: AutomationType;
}) {
  return (await api.automationApi.placeholderLabels(placeholderType)).data;
}

export function useAutomationPlaceholderLabels({
  api,
  placeholderType,
}: {
  api: ApiType;
  placeholderType: AutomationType;
}) {
  return useQuery({
    queryKey: automationQueryKeys.placeholderLabels(placeholderType),
    queryFn: () => automationPlaceholderLabelsQueryFn({ api, placeholderType }),
  });
}
